/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContextRef { 
    /**
     * Kind of the referenced entity. A closed set for now — new context kinds are added here as the app grows them.
     */
    type: ContextRef.TypeEnum;
    /**
     * Domain id of the referenced entity.
     */
    id: string;
    /**
     * Display label the app showed for the entity (a dashboard or KPI name). Echoed back in the message\'s `app.message-meta` entry so the chip survives a reload; never identity.
     */
    label?: string;
}
export namespace ContextRef {
    export type TypeEnum = 'bi.dashboard' | 'bi.kpi';
    export const TypeEnum = {
        Dashboard: 'bi.dashboard' as TypeEnum,
        Kpi: 'bi.kpi' as TypeEnum
    };
}


